import gql from 'graphql-tag';

const GET_SIGNUPS_V2_BY_DATE = gql`
  query GetSignupsV2ByDate(
    $campaignOrderId: ID!
    $startDate: String
    $endDate: String
  ) {
    getSignupsV2ByDate(
      campaignOrderId: $campaignOrderId
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      date
      signups
      customers
      uniqueIdentifiers
    }
  }
`;

export default GET_SIGNUPS_V2_BY_DATE;
